module.exports = function ($location) {
    return {
        restrict: 'A',
        require: 'olyDynamicContent',
        link(scope, element, attrs, olyDynamicContent) {
            function getScheduleKey(panel) {
                const path = $location.path();
                if (path) {
                    return path + (panel
                        ? `-${panel}`
                        : '');
                }

                return null;
            }

            function updateScheduleKey() {
                olyDynamicContent.scheduleKey(getScheduleKey(attrs.olyDcUrlSchedule));
            }

            updateScheduleKey();

            scope.$on('$locationChangeSuccess', updateScheduleKey.bind(this));
        },
    };
};



// WEBPACK FOOTER //
// ./src/common/dynamiccontent/dynamic-content-url-schedule.js